import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
	apiKey:
		process.env.REACT_APP_FIREBASE_API_KEY ||
		"AIzaSyAU53OZqQlamP_QUQbdHR76zgzZqQCsDmg",
	authDomain:
		process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
		"smart-prompts.firebaseapp.com",
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "smart-prompts",
	storageBucket:
		process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
		"smart-prompts.firebasestorage.app",
	messagingSenderId:
		process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "898061888437",
	appId:
		process.env.REACT_APP_FIREBASE_APP_ID ||
		"1:898061888437:web:57826c4cf9c73f26c347fc",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
